<template>
  <div class="w-100 space-for-navbar mb-3">
    <div
      id="SplashContainer"
      class="m-0 p-0 centered-on-page"
    >
      <div class="m-0 p-0 w-100 h-100">
        <svg
          class="m-0 p-0"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1000 560"
        >
          <title>BMG</title>
          <g id="Splashes">
            <g id="Home">
              <image
                id="HomePic"
                width="3101"
                height="1743"
                transform="translate(0.14 0.19) scale(0.33)"
                :xlink:href="require('../assets/medical_pics/DanSurgery.jpg')"
              />
              <g id="HomeLabel">
                <text
                  class="bmg-splashes-15"
                  transform="translate(347.64 140.95)"
                >N<tspan
                  class="bmg-splashes-16"
                  x="32.52"
                  y="0"
                >e</tspan><tspan
                  x="56.08"
                  y="0"
                >xt Ge</tspan><tspan
                  class="bmg-splashes-17"
                  x="159.24"
                  y="0"
                >n</tspan><tspan
                  x="186.4"
                  y="0"
                >e</tspan><tspan
                  class="bmg-splashes-18"
                  x="210.56"
                  y="0"
                >r</tspan><tspan
                  x="226.24"
                  y="0"
                >ation</tspan><tspan
                  x="0"
                  y="40"
                >In</tspan><tspan
                  class="bmg-splashes-19"
                  x="39.16"
                  y="40"
                >t</tspan><tspan
                  x="54.64"
                  y="40"
                >e</tspan><tspan
                  class="bmg-splashes-20"
                  x="78.8"
                  y="40"
                >r</tspan><tspan
                  class="bmg-splashes-21"
                  x="94.52"
                  y="40"
                >nal </tspan><tspan
                  class="bmg-splashes-22"
                  x="166.44"
                  y="40"
                >F</tspan><tspan
                  class="bmg-splashes-21"
                  x="191.36"
                  y="40"
                >i</tspan><tspan
                  class="bmg-splashes-3"
                  x="202.12"
                  y="40"
                >x</tspan><tspan
                  x="223.08"
                  y="40"
                >ation</tspan></text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(347.08 209.54)"
                ><tspan class="bmg-splashes-18">f</tspan><tspan
                  x="8.25"
                  y="0"
                >or Substantially Imp</tspan><tspan
                  class="bmg-splashes-14"
                  x="259.9"
                  y="0"
                >r</tspan><tspan
                  class="bmg-splashes-7"
                  x="269.6"
                  y="0"
                >ov</tspan><tspan
                  x="298.07"
                  y="0"
                >ed</tspan><tspan
                  x="24.35"
                  y="30"
                >O</tspan><tspan
                  class="bmg-splashes-10"
                  x="45.32"
                  y="30"
                >r</tspan><tspan
                  class="bmg-splashes-11"
                  x="55.72"
                  y="30"
                >t</tspan><tspan
                  class="bmg-splashes-6"
                  x="65.87"
                  y="30"
                >h</tspan><tspan
                  x="82.85"
                  y="30"
                >opedic Ou</tspan><tspan
                  class="bmg-splashes-24"
                  x="212.67"
                  y="30"
                >t</tspan><tspan
                  class="bmg-splashes-25"
                  x="222.35"
                  y="30"
                >c</tspan><tspan
                  x="236.2"
                  y="30"
                >o</tspan><tspan
                  class="bmg-splashes-26"
                  x="251.87"
                  y="30"
                >m</tspan><tspan
                  x="278.45"
                  y="30"
                >es</tspan></text>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <section class="bmg-half-page-section-view-white">
      <div class="row">
        <div class="col-md-6">
          <div class="view">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52.14 56.27"
              style="transform: rotate(20deg)"
            >
              <title>BMG Logo</title>
              <g id="BMG_Logo_Icon">
                <path
                  id="Right_1"
                  class="bmg-logo-svg-4"
                  d="M32.51,0H30.29c0,18.8,8.58,36.19,21.85,44.31V41.67C40.17,33.66,32.51,17.49,32.51,0Z"
                />
                <path
                  id="Right_2"
                  class="bmg-logo-svg-4"
                  d="M27.18,0H25c0,22.21,10.66,42,27.18,50.39V47.87C36.94,39.55,27.18,20.93,27.18,0Z"
                />
                <path
                  id="Right_3"
                  class="bmg-logo-svg-4"
                  d="M21.85,0H19.63c0,25.19,13.06,47.77,32.51,56.27V53.82C34,45.38,21.85,23.93,21.85,0Z"
                />
                <path
                  id="Left_1"
                  class="bmg-logo-svg-1"
                  d="M19.63,0h2.22c0,18.8-8.58,36.19-21.85,44.31V41.67C12,33.66,19.63,17.49,19.63,0Z"
                />
                <path
                  id="Left_2"
                  class="bmg-logo-svg-1"
                  d="M25,0h2.22C27.18,22.21,16.51,42,0,50.39V47.87C15.2,39.55,25,20.93,25,0Z"
                />
                <path
                  id="Left_3"
                  class="bmg-logo-svg-1"
                  d="M30.29,0h2.22C32.51,25.19,19.45,47.77,0,56.27V53.82C18.16,45.38,30.29,23.93,30.29,0Z"
                />
              </g>
            </svg>
            <div class="mask flex-center hm-gradient" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <h2 class="h1 text-center">
              Unmet Medical Needs Exist for Both Humans and Veterinary Patients
            </h2>
            <p class="h3">
              The frequent failure of conventional implants to maintain interfragmentary
              compression results in increased interfragmentary strain that interferes
              with primary bone healing and early weight bearing. This leads to increased
              risk of complications and longer recovery times. Long-bone fractures in
              horses often cannot be repaired. Elderly patients with major fractures may
              never recover.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="bmg-half-page-section-view-dark text-center p-4">
      <h1 class="h1">
        Ground Breaking Science
      </h1>
      <h5 class="h2 text-center mt-3">
        Numerical Analysis and Finite Element Quantify Hardware Loosening
      </h5>
      <div class="centered-on-page">
        <img
          src="../assets/medical_pics/Summary-50.jpg"
          class="img-fluid w-xs-100 w-lg-80"
        >
      </div>
      <div class="centered-on-page">
        <p class="mt-3 w-xs-90 w-lg-70 h4">
          Frequent failure of conventional implants to maintain interfragmentary
          compression has been known for decades. We quantified the osteoclastic
          resorption of necrotic bone causing it, and by doing so, gathered the
          required data for an engineering solution. We developed a novel approach
          to mitigate secondary gap widening, to sustain compression and stability
          for immediate weight bearing, exercise and primary bone healing
        </p>
      </div>
      <button
        type="button"
        class="bmg-btn-white mb-3"
        @click="goTo('Science', 'AnimationContainer')"
      >
        <span class="h5 font-bold">Go to Science</span>
      </button>
    </section>

    <div class="centered-on-page">
      <div class="bmg-large-section-white w-90 z-depth-5 p-5">
        <h2 class="display-4">
          Our Innovations
        </h2>
        <p class="h2">
          <em>Most fundamental improvement in internal fixation in 90+ years</em>
        </p>
        <section class="bmg-half-page-section-view-white z-depth-1 p-3">
          <div class="row">
            <div class="col-md-4 centered-on-page">
              <img
                src="../assets/hardware_pics/ScrewHeads.png"
                class="img-fluid w-75"
                alt="BMG Logo"
              >
            </div>
            <div class="col-md-4">
              <div class="d-flex flex-column justify-content-center align-items-center h-100 mb-3">
                <h1 class="heading mb-5 mt-3">
                  BMG Micro-spring Screws
                </h1>
                <h4 class="subheading mb-5">
                  Optimizing screw tension and thereby sustaining bone compression
                </h4>
                <button
                  type="button"
                  class="bmg-btn-white-outline"
                  @click="showMicroSpring=true"
                >
                  Learn More
                </button>
              </div>
            </div>
            <div class="col-md-4 centered-on-page">
              <img
                src="../assets/medical_pics/BMG_Stabalizing_Fracture.jpg"
                class="img-fluid w-80"
                alt="BMG Logo"
              >
            </div>
          </div>
        </section>
        <div
          id="MicroSpringLearnMore"
          class="w-100 m-0 p-0"
          v-show="showMicroSpring"
        >
          <div
            id="MicroSpringLearnMoreMask"
            class="bmg-modal-mask m-0 p-0 w-100"
          >
            <div
              id="MicroSpringLearnMoreModalWrapper"
              class="bmg-modal-wrapper my-3 p-3 w-100"
            >
              <div
                id="MicroSpringLearnMoreModalContainer"
                class="bmg-modal-container bg-dark"
                :style="(windowWidth > (windowHeight * 1.38)) ? {height: '100%', width: (windowHeight * 1.38) + 'px'} : {width: '100%', height: (windowWidth * 0.72) + 'px'}"
              >
                <svg
                  id="MicroSpringLearnMoreModalContainerClose"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 50 50.98"
                  class="bmg-popups-close-btn"
                  @click="showMicroSpring=!showMicroSpring"
                >
                  <title>Close</title>
                  <g
                    id="CloseButton"
                    data-name="CloseButton"
                  >
                    <circle
                      id="CloseButtonEllipse"
                      class="bmg-popups-close-button-1"
                      cx="25"
                      cy="25"
                      r="23"
                    />
                    <text
                      id="CloseButton-X"
                      class="bmg-popups-close-button-2"
                      transform="translate(10.43 39.8)"
                    >X</text>
                  </g>
                </svg>
                <img
                  v-show="!showMicroSpringMore"
                  class="img-fluid w-100"
                  src="../assets/medical_pics/BMGInventedHardwareToCloseResorptionGaps.jpg"
                >
                <img
                  v-show="showMicroSpringMore"
                  class="img-fluid w-100"
                  src="../assets/medical_pics/FullEarlyWeightBearingBenefits.jpg"
                >
                <button
                  type="button"
                  class="bmg-btn-white"
                  @click="showMicroSpringMore=!showMicroSpringMore"
                >
                  <span v-show="!showMicroSpringMore">
                    See More
                  </span>
                  <span v-show="showMicroSpringMore">
                    Go Back
                  </span>
                </button>
                <button
                  class="bmg-btn-white"
                  v-show="showMicroSpringMore"
                  @click="goTo('Science', 'AnimationContainer')"
                >
                  Go To Science
                </button>
              </div>
            </div>
          </div>
        </div>
        <section class="bmg-half-page-section-view-white z-depth-1 p-3">
          <div class="row">
            <div class="col-md-6">
              <div class="view">
                <img
                  src="../assets/purchased_pics/Vet_TibiaWithPlates.jpg"
                  class="img-fluid"
                  alt="BMG Logo"
                >
                <div class="mask flex-center hm-gradient" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-column justify-content-center align-items-center h-100 mb-3">
                <h1 class="heading mb-3">
                  BMG Sustained-Compression Plates
                </h1>
                <h4 class="subheading mb-3">
                  Stability for immediate weight-bearing and exercise
                  <hr class="my-3">
                  Equine tibia long-bone repair  – proof testing
                </h4>
                <button
                  type="button"
                  class="bmg-btn-white-outline"
                  @click="showPlates=!showPlates"
                >
                  See More
                </button>
              </div>
            </div>
          </div>
        </section>
        <div
          id="PlatesLearnMore"
          class="w-100 m-0 p-0"
          v-show="showPlates"
        >
          <div
            id="PlatesLearnMoreMask"
            class="bmg-modal-mask m-0 p-0 w-100"
          >
            <div
              id="PlatesLearnMoreModalWrapper"
              class="bmg-modal-wrapper my-3 p-3 w-100"
            >
              <svg
                id="PlatesLearnMoreModalContainerClose"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 50 50.98"
                class="bmg-popups-close-btn"
                @click="showPlates=!showPlates"
              >
                <title>Close</title>
                <g
                  id="CloseButton"
                  data-name="CloseButton"
                >
                  <circle
                    id="CloseButtonEllipse"
                    class="bmg-popups-close-button-1"
                    cx="25"
                    cy="25"
                    r="23"
                  />
                  <text
                    id="CloseButton-X"
                    class="bmg-popups-close-button-2"
                    transform="translate(10.43 39.8)"
                  >X</text>
                </g>
              </svg>
              <div
                id="PlatesLearnMoreModalContainer"
                class="bmg-modal-container bg-dark"
                :style="(windowWidth > (windowHeight * 1.38)) ? {height: '100%', width: (windowHeight * 1.38) + 'px'} : {width: '100%', height: (windowWidth * 0.72) + 'px'}"
              >
                <img
                  class="img-fluid w-100"
                  src="../assets/medical_pics/BMG_Equine_Bone_Plate_D2.jpg"
                >
              </div>
            </div>
          </div>
        </div>
        <section class="bmg-half-page-section-view-white z-depth-1 p-3 centered-on-page">
          <div class="row w-75">
            <div class="col-md-4">
              <div class="view">
                <img
                  src="../assets/medical_pics/Sutures.png"
                  class="img-fluid"
                  alt="Bone Sutures"
                >
                <div class="mask flex-center hm-gradient" />
              </div>
            </div>
            <div class="col-md-8">
              <div class="d-flex flex-column justify-content-center align-items-center h-100">
                <h1 class="heading mb-3">
                  BMG Bone Suture Fracture Repairs
                </h1>
                <h4 class="subheading mb-3">
                  Distal Tibial
                  <hr class="my-1">
                  Calcaneal
                  <hr class="my-1">
                  Long bone
                </h4>
                <button
                  type="button"
                  class="bmg-btn-white-outline"
                  @click="showSutures=!showSutures"
                >
                  See More
                </button>
              </div>
            </div>
          </div>
        </section>
        <div
          id="SuturesLearnMore"
          class="w-100 m-0 p-0"
          v-show="showSutures"
        >
          <div
            id="SuturesLearnMoreMask"
            class="bmg-modal-mask m-0 p-0 w-100"
          >
            <div
              id="SuturesLearnMoreModalWrapper"
              class="bmg-modal-wrapper my-3 p-3 w-100"
            >
              <svg
                id="SuturesLearnMoreModalContainerClose"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 50 50.98"
                class="bmg-popups-close-btn"
                @click="showSutures=!showSutures"
              >
                <title>Close</title>
                <g
                  id="CloseButton"
                  data-name="CloseButton"
                >
                  <circle
                    id="CloseButtonEllipse"
                    class="bmg-popups-close-button-1"
                    cx="25"
                    cy="25"
                    r="23"
                  />
                  <text
                    id="CloseButton-X"
                    class="bmg-popups-close-button-2"
                    transform="translate(10.43 39.8)"
                  >X</text>
                </g>
              </svg>
              <div
                id="SuturesLearnMoreModalContainer"
                class="bmg-modal-container bg-dark"
                :style="(windowWidth > (windowHeight * 1.38)) ? {height: '100%', width: (windowHeight * 1.38) + 'px'} : {width: '100%', height: (windowWidth * 0.72) + 'px'}"
              >
                <img
                  class="img-fluid w-100"
                  src="../assets/medical_pics/BoneSutureR1.jpg"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="centered-on-page">
          <div class="h3 mt-3 w-60">
            Our continuous-compression, micro-spring enhanced, hardware combines clinically
            relevant scientific research with innovative engineering to provide modern
            solutions for bone fractures.
          </div>
        </div>
        <button
          type="button"
          class="bmg-btn-dark mt-3"
          @click="goTo('Opportunity', 'top')"
        >
          Learn More
        </button>
      </div>
    </div>

    <!-- Investing -->
    <section class="text-center my-3 centered-on-page">
      <!-- Section heading -->
      <div>
        <div class="centered-on-page">
          <div>
            <div class="h1 text-dark font-weight-bold my-3">
              Investing in BMG's Market Transformative Orthopedic Hardware
            </div>
            <div class="h2 text-dark mx-auto mb-2">
              Help reinvent the standard for internal fixation in human and veterinary patients
            </div>
            <div class="h4 text-dark mx-auto mb-3 centered-on-page">
              <p class="w-80">
                Market for internal fixation is expected to substantially increase due
                to the increased confidence from BMG hardware performance
              </p>
            </div>
            <div>
              <button
                type="button"
                class="bmg-btn-white-outline my-3"
                @click="goTo('Investing', 'top')"
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
        <div>
          <div class="card-deck">
            <div class="card mb-4">
              <div class="view overlay">
                <img
                  class="card-img-top"
                  src="../assets/purchased_pics/rawpixel-440239-490x340.jpg"
                  alt="World Market"
                >
              </div>
              <div class="card-body">
                <!--Title-->
                <h4 class="card-title">
                  $7.6 Billion<br>World Market
                </h4>
                <!--Text-->
                <p class="card-text">
                  Total Addressable Market
                </p>
              </div>
            </div>
            <div class="card mb-4">
              <div class="view overlay">
                <img
                  class="card-img-top"
                  src="../assets/purchased_pics/shutterstock-1172580451-490x340.jpg"
                  alt="Annual Growth"
                >
              </div>
              <div class="card-body">
                <h4 class="card-title">
                  8%<br>Annual Growth
                </h4>
                <p class="card-text">
                  Human Orthopedics Market
                </p>
              </div>
            </div>
            <div class="card mb-4">
              <div class="view overlay">
                <img
                  class="card-img-top"
                  src="../assets/purchased_pics/shutterstock_1271305915_490x340.jpg"
                  alt="Daily Fractures"
                >
              </div>
              <div class="card-body">
                <h4 class="card-title">
                  16,000<br>Fractures / Day
                </h4>
                <p class="card-text">
                  Require Internal Fixation
                </p>
              </div>
            </div>
          </div>
          <div class="card-deck">
            <div class="card mb-4">
              <div class="view overlay">
                <img
                  class="card-img-top"
                  src="../assets/purchased_pics/rawpixel-id-646437-transparent-490x340.png"
                  alt="Capturable Market"
                >
              </div>
              <!--Card content-->
              <div class="card-body">
                <h4 class="card-title">
                  A New Gold Standard
                </h4>
                <p class="card-text">
                  Transformative, new generation, orthopedic hardware for trauma
                </p>
              </div>
            </div>
            <div class="card mb-4">
              <div class="view overlay">
                <img
                  class="card-img-top"
                  src="../assets/purchased_pics/shutterstock_590870102-490x340.jpg"
                  alt="Funding Round"
                >
              </div>
              <div class="card-body">
                <h4 class="card-title">
                  $1 M to $1.3 Million<br>Current Raise
                </h4>
                <p class="card-text">
                  Simple Agreement for Future Equity (SAFE) Securities
                </p>
              </div>
            </div>
            <div class="card mb-4">
              <div class="view overlay">
                <img
                  class="card-img-top"
                  src="../assets/purchased_pics/shutterstock-433689337-original-temp-490x340.jpg"
                  alt="Valuation"
                >
              </div>
              <div class="card-body">
                <h4 class="card-title">
                  $4 to $22 Million<br>Company Valuation Increase
                </h4>
                <p class="card-text">
                  Expected Following Successful Horse Tibia Fracture Repair
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Card deck -->
    </section>
    <!-- End Investing -->
  </div> <!-- END of MainPage content -->
</template>

<script>
import SecurityCheckMixin from './mixins/SecurityCheckMixin'

export default {
  mixins: [SecurityCheckMixin],
  name: 'MainPage',
  data: function () {
    return {
      windowHeight: -1,
      windowWidth: -1,
      showMicroSpring: false,
      showMicroSpringMore: false,
      showPlates: false,
      showSutures: false
    }
  },
  props: [],
  components: {},
  computed: {
    xsScreenMax () {
      return this.$store.state.constants.SCREEN_XS_MAX
    },
    smScreenMax () {
      return this.$store.state.constants.SCREEN_SM_MAX
    },
    mdScreenMax () {
      return this.$store.state.constants.SCREEN_MD_MAX
    },
    lgScreenMax () {
      return this.$store.state.constants.SCREEN_LG_MAX
    },
    xlScreenMax () {
      return this.$store.state.constants.SCREEN_XL_MAX
    }
  },
  methods: {
    respondToWindowSizeChange () {
      if (window.innerHeight) {
        this.windowHeight = window.innerHeight
      } else if (document.body && document.body.offsetHeight) {
        this.windowHeight = document.body.offsetHeight
      }

      if (window.innerWidth) {
        this.windowWidth = window.innerWidth
      } else if (document.body && document.body.offsetWidth) {
        this.windowWidth = document.body.offsetWidth
      }
      // console.log('Window = ' + this.windowWidth + ' x ' + this.windowHeight)
      // console.log('this.windowWidth = ', this.windowWidth)
      // console.log('this.windowHeight = ', this.windowHeight)
    },
    scrollToSection (section) {
      // console.log('Attempting to scroll to ' + section + ' section...')
      if (section) {
        var desiredSection = document.getElementById(section)
        // console.log('Section = ')
        // console.log(desiredSection)
        if (desiredSection) {
          desiredSection.scrollIntoView()
        }
      }
    },
    goTo (_name, _section) {
      this.$router.push({ name: _name, params: { section: _section } })
    }
  },
  created () {},
  beforeMount () {},
  mounted () {
    this.respondToWindowSizeChange()
    window.addEventListener('resize', this.respondToWindowSizeChange)
    // console.log('Section = ' + this.$route.params.section)
    this.scrollToSection(this.$route.params.section)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
